define([
	"underscore",
	"csi/def",
	"csi/def/ActionFactory",
	"csi/def/ViewRef",
	"./_CustomViewAction"
], function(_, def, ActionFactory, ViewRef, _CustomViewAction) {
	return ActionFactory.declare("CustomViewSaveAsOnToolbar", _CustomViewAction, {
		classController: "csi/view/customview/SaveAsController",
		constructor() {
			this.m_viewRef = Object.assign(new ViewRef(), { m_id: def.DEFAULT_FORM_ID });
		},
	});
});